<template>
  <div class="device-auth-setting">
    <el-row v-show="managerType !== 'ADMIN'" type="flex" :gutter="15" class="h100">
      <el-col :span="14" class="h100">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h4 mr-r10">관리 대상</div>
            <i class="fas fa-info-circle" style="cursor: pointer;" @click="clickDeviceAuthInfo"></i>
          </div>
          <el-radio-group class="ordinary mr-r4" v-model="objListType" size="small">
            <el-radio-button label="LOGICAL">논리</el-radio-button>
            <el-radio-button label="PHYSICAL">물리</el-radio-button>
          </el-radio-group>
        </el-row>
        <w-logical-obj-table v-show="objListType==='LOGICAL'" :active="showFlag && managerType !== 'ADMIN'" ref="logicalObjTable" :checked-obj-list="checkedObjList"
        :except-define-ids="['NETINTERFACE']" :fit-height="fitHeight" class="h100"/>
        <w-physical-obj-table v-show="objListType=='PHYSICAL'" :managetype-data="managetypeList" :checked-obj-list="checkedObjList" ref="physicalObjTable"
        :active="showFlag && managerType !== 'ADMIN'" :show-interface-column="false"  :fit-height="fitHeight" class="h100"/>
        <el-row v-if="activeManagetypeIds.indexOf('NMS') >= 0 && flowAnalysisAuthFlag != null" type="flex" justify="space-between">
          <div class="title-h4">플로우 분석 권한</div>
          <el-switch v-model="flowAnalysisAuth" active-value="Y" inactive-value="N" ></el-switch>
        </el-row>
      </el-col>
      <el-col :span="10" class="h100">
        <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
          <div class="vertical-center-box">
            <div class="title-h4 mr-r10 vertical-center-box" style="height:31px">대상 목록</div>
          </div>
        </el-row>
        <w-selected-obj-table ref="selectedObjTable" title="대상 목록" :checked-obj-list="checkedObjList" @reload-obj-list="reloadObjList"
        :fit-height="fitHeight" class="h100"/>
      </el-col>
    </el-row>
    <el-row v-show="managerType === 'ADMIN'">
      <span class="info-text">Admin 역할은 모든 장비에 대해 모니터링, 액션, 개별 설정, 공통 설정 권한이 부여됩니다.</span>
    </el-row>
  </div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import filter from 'lodash/filter';
import { isTrue } from '@/utils/boolean';
import WSelectedObjTable from '@/components/table/SelectedObjTable';
import WPhysicalObjTable from '@/components/table/PhysicalObjTable/index';
import WLogicalObjTable from '@/components/table/LogicalObjTable/index';

export default {
  name: 'WDeviceAuthSetting',
  components: {
    WSelectedObjTable,
    WPhysicalObjTable,
    WLogicalObjTable,
  },
  props: {
    fitHeight: {
      type: Boolean,
      default: false,
    },
    managerType: {
      tyep: String,
      default: null,
    },
    showFlag: {
      type: Boolean,
      default: false,
    },
    checkedObjList: {
      type: Array,
      default: () => [],
    },
    flowAnalysisAuthFlag: {
      type: String,
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    showFlag: {
      handler(value) {
        if (value) {
          if (!isEqual(this.managerType, 'ADMIN')) {
            this.loadData();
          }
        }
      },
      immediate: true,
    },
    objListType() {
      this.reloadObjList();
    },
  },
  data() {
    return {
      flowAnalysisAuth: 'y',
      objListType: 'LOGICAL',
    };
  },
  computed: {
    activeManagetypeIds() {
      return this.$store.getters.activeManagetypeIds;
    },
    managetypeList() {
      return filter(this.$store.getters.activeManagetypes, (item) => isTrue(item.showFlag));
    },
  },
  methods: {
    initData() {
      this.objListType = 'LOGICAL';
      if (this.managerType !== 'ADMIN') {
        this.$refs.logicalObjTable.initData();
        this.$refs.physicalObjTable.initData();
        this.$refs.selectedObjTable.initData();
      }
    },
    loadData() {
      if (!this.active) {
        return;
      }
      this.flowAnalysisAuth = this.flowAnalysisAuthFlag;
    },
    clickDeviceAuthInfo() {
      this.$emit('click-device-auth-info');
    },
    /**
     * 2019-08-12
     * [ND에 관련된 netinterface를 서비스단에서 추가/삭제할 것이기에 관련된 ND 대상만 보내도록한다.]
     * 추가적으로 서비스(SVC)는 관리대상의 element_id들과 기존 objId 권한 중복 및 판단이 어려워 현재 기능 유지
     * @author Song
     */
    getDeviceAuthSettingData() {
      const checkedObjList = this.checkedObjList;
      const objIds = [];
      checkedObjList.forEach((object) => {
        const objId = object.objId;
        if (!objIds.includes(objId) && object.objDefineId !== 'NETINTERFACE') {
          objIds.push(objId);
        }
      });
      const data = {
        objIds,
        flowAnalysisAuthFlag: this.flowAnalysisAuth,
      };
      return data;
    },
    reloadObjList() {
      const value = this.objListType;
      if (!isNil(value)) {
        if (isEqual(value, 'LOGICAL')) {
          this.$refs.logicalObjTable.setCheckObjTable();
        } else {
          this.$refs.physicalObjTable.setCheckObjTable();
        }
      }
    },
  },
};
</script>

<style lang="scss">
.device-auth-setting {
  .el-button--mini {
    -webkit-padding-before: 7px !important;
    padding-top: 8px;
  }
  .el-radio-group.ordinary {
    .el-radio-button__inner {
      -webkit-padding-before: 9px !important;
      padding-top: 8px;
      padding-right: 12px;
      -webkit-padding-after: 8px !important;
      padding-bottom: 9px;
      padding-left: 12px;
    }
  }
}
.h100 {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/UserAndAuthManagement/UserSettings/components/DeviceAuthSetting.vue